import React, { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Loader, Text, Stack, Group, LoadingOverlay } from "@mantine/core";
import { IconX, IconCheck } from "@tabler/icons-react";
import useStatusCheck from "../../../hooks/useStatusCheck";
import { DataContext } from "../../../context/DataContext";
const ClearReturn = () => {
  const { settings, data } = useContext(DataContext);
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("PENDING");
  const [loading, setLoading] = useState(true);

  useStatusCheck(true, false, "idmax");

  useEffect(() => {
    const fetchStatus = async () => {
      setLoading(true);

      const requestData = {
        ...data,
        state: searchParams.get("state"),
        isIDMaxContinue: true,
        provider: "CLEAR",
        redirect_uri: "https://fe.dcams.app/clear/return"
      };

      // Always use the standard backend URL, never vx.dcams.app
      const primaryUrl = `${process.env.REACT_APP_BACKEND_URL}/v3/stable/api/frontend/idmax`;

      const tryFetch = async (url) => {
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });

          if (!response.ok) {
            console.warn(`HTTP error from ${url}: ${response.status}`);
            return null;
          }

          const result = await response.json();
          
          // Check if we got valid data
          if (!result || result.data === false) {
            console.warn(`No valid data returned from ${url}`);
            return null;
          }

          return result;
        } catch (error) {
          console.warn(`Failed to fetch from ${url}:`, error);
          return null;
        }
      };

      // Fetch from the backend URL
      let data_returned = await tryFetch(primaryUrl);
      
      if (data_returned) {
        setStatus(data_returned.status);
      } else {
        console.error("Error fetching status from backend");
        setStatus("ERROR");
      }
      
      setLoading(false);
    };

    fetchStatus();
  }, [searchParams]);

  useEffect(() => {
    // Attempt to close the current tab
    if (status === "PENDING") {
      return;
    }
    window.close();
  }, [status]);

  return <LoadingOverlay visible />;
};

export default ClearReturn;
